import { render, staticRenderFns } from "./ListManager.vue?vue&type=template&id=b0bc5e26&"
import script from "./ListManager.vue?vue&type=script&lang=js&"
export * from "./ListManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports